import React from "react";
import { Link } from "gatsby";
import styled from "@emotion/styled";

import { DarkModeToggle } from "~/components/DarkModeToggle";

const Wrapper = styled.header({
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "0.75rem 1.5rem",
  paddingBottom: "1.5rem",
  marginBottom: "3.5rem",
  borderBottom: "1px solid var(--border)",
});

const Logo = styled(Link)({
  fontSize: "1.4rem",
  fontWeight: 500,
  color: "var(--textTitle)",
  textDecoration: "none",
});

const Nav = styled.nav({
  display: "flex",
  alignItems: "center",
  gap: "1.5rem",
  "& a": {
    color: "var(--textNormal)",
    textDecoration: "none",
  },
  "& a:hover": {
    textDecoration: "underline",
  },
});

const ResumeLink = styled.a({
  fontWeight: 600,
  whiteSpace: 'nowrap'
});

type HeaderProps = {
  title: string;
};

const Header = ({ title }: HeaderProps) => (
  <Wrapper>
    <Logo to="/">{title}</Logo>
    <Nav>
      <Link to="/#work">Work</Link>
      <Link to="/contact">Contact</Link>
      <ResumeLink href="/resume.pdf" target="_blank" rel="noopener noreferrer">
        Resume <span aria-hidden="true">↗</span>
        <span className="visually-hidden"> (PDF, opens in new tab)</span>
      </ResumeLink>
      <DarkModeToggle />
    </Nav>
  </Wrapper>
);

export default Header;
